export enum ROUTES {
    START = '/start',
    ABOUT = 'o-nas',
    SPECIALIZATIONS = '/specjalizacje',
    TEAM = '/zespol',
    NEWS = '/aktualnosci',
    UMOWA_STOI = 'http://umowastoi.pl',
    LOKALNIE_LEGALNIE = 'http://lokalnielegalnie.pl',
    CONTACT = '/kontakt'
}